import { render, staticRenderFns } from "./SolicitacaoAtribuirResponsavel.vue?vue&type=template&id=66839214&scoped=true&"
import script from "./SolicitacaoAtribuirResponsavel.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAtribuirResponsavel.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoAtribuirResponsavel.vue?vue&type=style&index=0&id=66839214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66839214",
  null
  
)

export default component.exports